export const getOrderIdFromUrl = () => {
  const paths = window.location.pathname.split('/').filter(Boolean);

  if (window.location.pathname.includes('stripe-redirect')) {
    return paths?.[3];
  }
  return paths?.[2];
};
